import React from 'react';
import { Trans } from '@lingui/react/macro';

function MultipleTabsInUse() {
    return (
        <div className="container mx-auto">
            <p className="mt-4">
                <Trans id="multiple_tabs_in_use_text">
                    Using multiple tabs for this application is not supported, please close this tab and continue in the main - active tab.
                </Trans>
            </p>
        </div>
    );
}

export default MultipleTabsInUse;